export default "__VITE_ASSET__DhzE3EPY__"